import { STORAGE_KEYS } from '@/utils/storageKeys'
import { clearSessionMeta } from '@/utils/sessionConfig'
import {
  usesHttpOnlyRefresh,
  setRefreshTokenDelivery,
  clearRefreshTokenDelivery,
  purgeLegacyRefreshFromStorage,
} from '@/utils/refreshTokenDelivery'

export { setRefreshTokenDelivery, usesHttpOnlyRefresh }

export function getAccessToken() {
  return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
}

export function getRefreshToken() {
  return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
}

export function setAuthTokens({ accessToken, refreshToken, clearRefreshIfMissing = false, refreshTokenDelivery } = {}) {
  if (refreshTokenDelivery) {
    setRefreshTokenDelivery(refreshTokenDelivery)
  }

  if (accessToken) {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken)
  }

  if (usesHttpOnlyRefresh()) {
    purgeLegacyRefreshFromStorage()
    return
  }

  if (refreshToken) {
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken)
  } else if (clearRefreshIfMissing) {
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  }
}

export function clearAuthTokens() {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.USER)
  localStorage.removeItem(STORAGE_KEYS.ADMIN_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.ADMIN_USER)
  localStorage.removeItem(STORAGE_KEYS.ADMIN_REFRESH_TOKEN)
  clearRefreshTokenDelivery()
  clearSessionMeta()
}

export function stashAdminSessionForImpersonate() {
  const refresh = getRefreshToken()
  if (refresh) {
    localStorage.setItem(STORAGE_KEYS.ADMIN_REFRESH_TOKEN, refresh)
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  }
}

export function restoreAdminRefreshToken() {
  const adminRefresh = localStorage.getItem(STORAGE_KEYS.ADMIN_REFRESH_TOKEN)
  if (adminRefresh) {
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, adminRefresh)
    localStorage.removeItem(STORAGE_KEYS.ADMIN_REFRESH_TOKEN)
  }
}

export function isImpersonatingSession() {
  return !!localStorage.getItem(STORAGE_KEYS.ADMIN_TOKEN)
}

export function shouldAttemptSilentRefresh() {
  if (isImpersonatingSession()) {
    return false
  }
  if (usesHttpOnlyRefresh()) {
    return true
  }
  return !!getRefreshToken()
}

export function getAccessTokenExpiryMs() {
  const token = getAccessToken()
  if (!token) return null

  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    if (payload.exp) {
      return payload.exp * 1000
    }
  } catch (_) {
    /* ignore */
  }

  return null
}
